import React from "react";

import Career from "../Component/Career";
import Joinus from "../Component/Joinus";
import Currentopening from "../Component/Currentopening";



const Contactus = () => {
    return (
     <>
 
  <Career/>
  <Joinus/>
  <Currentopening/>
 
  
  
    
  
      
  </>
      
    );
  };
  
  export default Contactus;
  